import { useSuspenseQuery } from "@tanstack/react-query";
import * as React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { getRouteTreeRoot } from "~/shared/api/users/users.helpers";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";
import { ButtonLink } from "../ds/ButtonLink";

export function GoBackHome() {
  return (
    <ErrorBoundary fallback={null}>
      <React.Suspense
        fallback={
          <ButtonLink to="/" size="sm-to-lg">
            Go Back Home
          </ButtonLink>
        }
      >
        <GoBackHomeButtonLink />
      </React.Suspense>
    </ErrorBoundary>
  );
}

function GoBackHomeButtonLink() {
  const { data: user } = useSuspenseQuery(USERS_QUERIES.profile());
  const routeTreeRoot = getRouteTreeRoot(user.type);

  return (
    <ButtonLink to={routeTreeRoot} size="sm-to-lg">
      Go Back Home
    </ButtonLink>
  );
}
